"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Department {
}
exports.default = Department;
//# sourceMappingURL=Department.js.map